import { Box, FormLabel, Grid, MenuItem, Select, Typography, SelectChangeEvent } from "@mui/material";
import BreadCrumbs from "../../ui/BreadCrumbs";
import { Card } from "../../ui/Card";
import Title from "../../ui/Title";
import { StyledInput } from "../../ui/StyledInput";
import { useEffect, useState } from "react";
import { fetchSingleRoles, fetchAllRoles, putSingleRoles } from "../../../config/api";
import { useNavigate, useParams } from 'react-router-dom';
import { StyledButton } from "../../ui/StyledButton";
import toast from "react-hot-toast";

export interface RoleFormData {
    first_name: string;
    last_name: string;
    username: string;
    email: string;
    user_type: string;
    status: string;
    modules: string[];
}

const UserRoleEdit = () => {
    const [canSubmit, setCanSubmit] = useState(false);
    const [sideBar, setSideBar] = useState<any[]>([]);

    const [formData, setFormData] = useState<RoleFormData>({
        first_name: "",
        last_name: "",
        username: "",
        email: "",
        status: "",
        user_type: "",
        modules: [],
    });


    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name } = event.target;

        setFormData({ ...formData, [name]: event.target.value });
    };

    const handleSelectChange = (event: SelectChangeEvent<string[]>) => {
        setFormData({
            ...formData,
            modules: event.target.value as string[],
        });
    };


    const { user_id } = useParams<{ user_id: string }>();


    useEffect(() => {

        fetchAllRoles()
            .then((data) => {
                setSideBar(data.data.data)
                const sideBar_val = data.data.data as any[];
                fetchSingleRoles(user_id)
                    .then((data) => {
                        const userData = data.data.data[0].userData;
                        const userRoleData = data.data.data[0].userRoleData;
                        var old_permissition = userRoleData.modules;

                        userRoleData.modules = []

                        sideBar_val.map((item) => {

                            old_permissition.map((item2: any) => {
                                if (item.id === item2) {
                                    userRoleData.modules.push(item.name);
                                }
                            })
                        });



                        const combinedData = {
                            ...userData,
                            ...userRoleData,
                            modules: userRoleData.modules || []
                        };

                        console.log(combinedData);

                        setFormData(combinedData);
                    })
                    .catch((error) => console.log(error));
            })
            .catch((error) => {
                console.error('Error fetching roles:', error);
            });



    }, [user_id])



    const navigate = useNavigate();

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        var new_permisstion = formData.modules;
        formData.modules = [];
        sideBar.map((item) => (
            new_permisstion.map((item2) => {
                if (item.name === item2) {
                    formData.modules.push(item.id);
                }
            })
        ));

        putSingleRoles(user_id, formData).then(() => {
            toast.success("User Update Successfully");
            navigate(`/settings/user-role-management/`);
        })
            .catch((error) => {
                console.log("error ", error);
            });
    };

    return (
        <>
            <BreadCrumbs
                field="Settings"
                link={"/settings"}
                extra={[
                    {
                        text: "User Role Management",
                    },
                ]}
            />
            <Card>

                <form onSubmit={handleSubmit}>
                    <Grid container mt={2}>
                        <Grid item xs={12} md={6} gap={4}>

                            <Title title={'Edit Roles'} />
                            <Typography marginBottom={2}>
                                User Role*
                            </Typography>


                            <Grid item xs={12} md={12} pb={2}>
                                <FormLabel>
                                    <Typography fontSize={12}>First Name</Typography>
                                </FormLabel>
                                <StyledInput
                                    onChange={handleInputChange}
                                    name="first_name"
                                    placeholder="enter first name"
                                    fullWidth
                                    value={formData.first_name}
                                />
                            </Grid>

                            <Grid item xs={12} md={12} pb={2}>
                                <FormLabel>
                                    <Typography fontSize={12}>Last Name</Typography>
                                </FormLabel>
                                <StyledInput
                                    onChange={handleInputChange}
                                    name="last_name"
                                    placeholder="enter last name"
                                    fullWidth
                                    value={formData.last_name}
                                />
                            </Grid>


                            <Grid item xs={12} md={12} pb={2}>
                                <FormLabel>
                                    <Typography fontSize={12}>User Name</Typography>
                                </FormLabel>
                                <StyledInput
                                    onChange={handleInputChange}
                                    name="username"
                                    placeholder="enter username"
                                    fullWidth
                                    value={formData.username}
                                />
                            </Grid>

                            <Grid item xs={12} md={12} pb={2}>
                                <FormLabel>
                                    <Typography fontSize={12}>User Email</Typography>
                                </FormLabel>
                                <StyledInput
                                    onChange={handleInputChange}
                                    name="email"
                                    placeholder="enter user email"
                                    fullWidth
                                    value={formData.email}

                                />
                            </Grid>

                            <Grid item xs={12} md={12} pb={2}>
                                <FormLabel>
                                    <Typography fontSize={12}>Select Modules</Typography>
                                </FormLabel>
                                <Select
                                    fullWidth
                                    multiple
                                    value={formData.modules}
                                    onChange={handleSelectChange}
                                    renderValue={(selected: string[]) => selected.join(', ')}
                                    sx={{
                                        minWidth: '50%',
                                        borderRadius: "16px",
                                        background: "#fff",
                                        boxShadow:
                                            "-1px -1px 4px 0px rgb(255, 255, 255), 2px 2px 6px 0px rgba(0, 0, 0, 0.2) !important",
                                    }}
                                >
                                    {sideBar.map((item) => (
                                        <MenuItem key={item.id} value={item.name}>
                                            {item.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>

                            <Grid item xs={12} md={12} pb={2}>
                                <FormLabel>
                                    <Typography fontSize={12}>User Status</Typography>
                                </FormLabel>

                                <Select
                                    fullWidth
                                    labelId="demo-select-small-label"
                                    value={formData.status}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            status: e.target.value,
                                        })
                                    }
                                    sx={{
                                        backgroundColor: 'white',
                                    }}
                                >
                                    <MenuItem value={"true"}>Acitve</MenuItem>
                                    <MenuItem value={"false"}>InAcitve</MenuItem>
                                </Select>
                            </Grid>

                            <Grid item xs={12} md={12} pb={2}>
                                <StyledButton
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                >
                                    Save
                                </StyledButton>
                            </Grid>

                        </Grid>
                    </Grid>
                </form >
            </Card>

        </>
    )
}

export default UserRoleEdit;